// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n7Lu","importantInfo":"styles_importantInfo__2Q-9V"};